var _rect, _path, _rect2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPortfolio = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 18H28.425C28.2509 17.1536 27.7904 16.393 27.1209 15.8465C26.4515 15.3001 25.6142 15.0011 24.75 15L23.25 15C22.3858 15.0011 21.5485 15.3001 20.8791 15.8465C20.2096 16.393 19.7491 17.1536 19.575 18H18.75C17.7558 18.0012 16.8027 18.3967 16.0997 19.0997C15.3967 19.8027 15.0012 20.7558 15 21.75V29.25C15.0012 30.2442 15.3967 31.1973 16.0997 31.9003C16.8027 32.6033 17.7558 32.9988 18.75 33H29.25C30.2442 32.9988 31.1973 32.6033 31.9003 31.9003C32.6033 31.1973 32.9988 30.2442 33 29.25V21.75C32.9988 20.7558 32.6033 19.8027 31.9003 19.0997C31.1973 18.3967 30.2442 18.0012 29.25 18ZM23.25 16.5H24.75C25.2137 16.5019 25.6655 16.6471 26.0435 16.9156C26.4216 17.1841 26.7074 17.5628 26.862 18H21.138C21.2926 17.5628 21.5784 17.1841 21.9565 16.9156C22.3345 16.6471 22.7863 16.5019 23.25 16.5ZM18.75 19.5H29.25C29.8467 19.5 30.419 19.7371 30.841 20.159C31.2629 20.581 31.5 21.1533 31.5 21.75V24H16.5V21.75C16.5 21.1533 16.7371 20.581 17.159 20.159C17.581 19.7371 18.1533 19.5 18.75 19.5ZM29.25 31.5H18.75C18.1533 31.5 17.581 31.2629 17.159 30.841C16.7371 30.419 16.5 29.8467 16.5 29.25V25.5H23.25V26.25C23.25 26.4489 23.329 26.6397 23.4697 26.7803C23.6103 26.921 23.8011 27 24 27C24.1989 27 24.3897 26.921 24.5303 26.7803C24.671 26.6397 24.75 26.4489 24.75 26.25V25.5H31.5V29.25C31.5 29.8467 31.2629 30.419 30.841 30.841C30.419 31.2629 29.8467 31.5 29.25 31.5Z",
    fill: "#381E42"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#E9F3F6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPortfolio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/portfolio.036cdb4b.svg";
export { ForwardRef as ReactComponent };